import { createElement, useState } from 'react';
import { Box, Text } from '@chakra-ui/layout';
import { Spinner } from '@chakra-ui/spinner';
import { Select } from '@laliga-cdac/select';
import { useBreakpointValue } from '@chakra-ui/react';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var darkBgs = ['black', 'green', 'blue', 'red', 'purple', 'cyan', 'orange'];

var getTextColor = function getTextColor(bgColor) {
  return darkBgs.includes(bgColor.replace("corporate", "").toLocaleLowerCase()) ? 'white' : 'black';
};

var allItem = function allItem(t) {
  return {
    id: 0,
    label: t ? t('all') : 'Todos',
    value: 'all'
  };
};

var activeItemStyles = function activeItemStyles(color, darkMode, contrastColor) {
  return {
    fontWeight: 'bold',
    bgColor: contrastColor || (darkMode ? DARK_MODE_COLOR : getTextColor(color.split('.')[0])),
    color: color
  };
};

var defaultItemStyles = function defaultItemStyles(color, darkMode) {
  return {
    border: "1px solid " + (darkMode ? DARK_MODE_COLOR : getTextColor(color.split('.')[0])),
    bg: color
  };
};

var DARK_MODE_COLOR = 'black';
var _excluded = ["itemStyles", "children", "size"];

var padding = function padding(size) {
  switch (size) {
    case 'sm':
      return '2px';

    case 'md':
      return '6px';

    case 'lg':
      return '8px';

    default:
      return '6px';
  }
};

var ItemOption = function ItemOption(_ref) {
  var itemStyles = _ref.itemStyles,
      children = _ref.children,
      size = _ref.size,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return createElement(Box, Object.assign({
    p: padding(size),
    minW: "115px",
    borderRadius: "5px",
    cursor: "pointer",
    pos: "relative",
    m: "0.5em"
  }, itemStyles, {
    textAlign: "center"
  }, rest, {
    fontSize: size || 'md'
  }), children);
};

var _excluded$1 = ["items", "selectedItem", "onChange", "title", "loading", "bg", "bgColor", "backgroundColor", "loadingLabel", "component", "darkMode", "translation", "centered", "size", "contrastColor"];

var OptionFilter = function OptionFilter(_ref) {
  var items = _ref.items,
      _onChange = _ref.onChange,
      title = _ref.title,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      bg = _ref.bg,
      bgColor = _ref.bgColor,
      backgroundColor = _ref.backgroundColor,
      loadingLabel = _ref.loadingLabel,
      component = _ref.component,
      darkMode = _ref.darkMode,
      translation = _ref.translation,
      centered = _ref.centered,
      size = _ref.size,
      contrastColor = _ref.contrastColor,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var _React$useState = useState(0),
      activeItem = _React$useState[0],
      setActiveItem = _React$useState[1];

  var _backgroundColor = (bg || bgColor || backgroundColor || 'white').toString();

  var isMd = useBreakpointValue({
    base: false,
    md: true
  });
  var fontColor = (contrastColor == null ? void 0 : contrastColor.toString()) || (darkMode ? DARK_MODE_COLOR : getTextColor(_backgroundColor.split('.')[0]));
  return createElement(Box, Object.assign({
    w: "full",
    d: "flex",
    minH: "4.8125em",
    justifyContent: "flex-start",
    flexDirection: {
      base: 'column',
      md: 'row'
    },
    p: "0.7em",
    bg: _backgroundColor,
    color: fontColor
  }, rest), title && createElement(Box, {
    d: "flex",
    alignItems: "center",
    minW: "fit-content",
    w: {
      base: '100%',
      md: '5%'
    },
    m: "0.5em"
  }, createElement(Text, {
    w: "full",
    p: "6px",
    fontSize: size || 'md',
    textAlign: {
      base: 'center',
      md: 'center'
    }
  }, title)), createElement(Box, {
    w: "full",
    d: "flex",
    justifyContent: "flex-start",
    flexDirection: "row"
  }, createElement(Box, {
    w: "full",
    d: "flex",
    justifyContent: centered ? 'center' : 'flex-start',
    alignItems: "center",
    flexWrap: "wrap"
  }, loading ? createElement(Box, {
    d: "flex",
    mr: "1em",
    alignItems: "center"
  }, ' ', loadingLabel && createElement(Text, {
    mr: "1em",
    ml: "1em",
    fontSize: size || 'md'
  }, ' ', loadingLabel), ' ', createElement(Spinner, {
    title: "cagando"
  })) : !isMd ? createElement(Box, {
    m: "0.5em",
    w: "inherit"
  }, createElement(Select, {
    options: items,
    closeMenuOnSelect: false,
    onChange: function onChange(e) {
      var item = e;

      if (_onChange) {
        _onChange(item == null ? void 0 : item.value);
      }
    }
  })) : [allItem(translation || null)].concat(items).map(function (item) {
    var itemStyles = item.id === activeItem ? activeItemStyles(_backgroundColor, darkMode, contrastColor == null ? void 0 : contrastColor.toString()) : defaultItemStyles(_backgroundColor, darkMode);
    return createElement(ItemOption, {
      itemStyles: itemStyles,
      borderColor: contrastColor == null ? void 0 : contrastColor.toString(),
      textTransform: item.id === 0 ? 'uppercase' : 'capitalize',
      key: item.id,
      onClick: function onClick() {
        setActiveItem(item.id);

        if (item.value && _onChange) {
          _onChange(item.value);
        }
      },
      size: size
    }, item.label);
  })), component && createElement(Box, {
    d: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  }, component)));
};

export default OptionFilter;